import {translate} from 'shared/services/I18nService';
// This usage causes issues unit testing since i18n is not initializaed. TODO: Find a better startup strategy
let $t = translate.scope('shared.assert');

export const assert = {
  isRequired (obj, source) {
    const missingKeys = Object.keys(obj).filter(key => obj[key] === undefined);
    validate(missingKeys, source, $t('missing-required-fields'));
  },

  isNotEmptyArray (obj, source) {
    const missingKeys = Object.keys(obj).filter(key => !Array.isArray(obj[key]) || obj[key].length === 0);
    validate(missingKeys, source, $t('fields-arrays-with-at-least-one-value'));
  },

  isNumeric (obj, source) {
    const invalidKeys = Object.keys(obj).filter(key => Number.isNaN(Number(obj[key])));
    validate(invalidKeys, source, $t('fields-should-numbers'));
  },

  isOneOf (actual, allowed, source) {
    if (!allowed.includes(actual)) {
      const message = `${source || ''} ${$t('validation-check')} ${actual} ${$t('should-be-one-of')} "${allowed.join(',')}".`;
      throw new Error(message);
    }
  }
};

function validate (missingKeys, source, error) {
  if (missingKeys.length > 0) {
    const message = `${source || ''} ${$t('validation-check')} ${error}: "${missingKeys.join(',')}".`;
    throw new Error(message);
  }
}



// WEBPACK FOOTER //
// ./src/shared/util/assert.js